export default __webpack_public_path__ + "static/media/undo-solid.0bdc6183.svg";